WiseMetering.Model.IntegrationLicenseLogs = WiseMetering.Model.extend({
    urlRoot: '/integrations_logs'
});
